import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import ButtomCustom from "../../ButtonRound";
import HttpClient from "../../../helpers/HttpClient";
import { showToast } from "../../../utils/toast";
import OverlayLoader from "../../OverlayLoader";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MobileStepper from "../../Steppers/components/MobileStepper";
import AlertModal from "../../Tests/components/AlertModal";

import ReadingTest from "../components/ReadingTest";
import TestInstructions from "../components/TestInstructions";
import QuizContainer from "../../Quiz/QuizContainer";

const TestContainer = ({
  courseCode,
  type,
  data,
  configPercentage,
  onFinalize,
  onContinue,
}) => {
  const [openLoader, setOpenOpenLoader] = useState(false);
  const authState = useSelector((state) => state.auth);
  const userId = authState && authState.user ? authState.user.email : "test";
  const [quizData, setQuizData] = useState(null);
  const [step, setStep] = useState(0);
  const secondsReading = useRef(0)

  const loadData = async () => {
    let url = `/quiz/data-lect/${userId}/${courseCode}/${type}/${
      type == "LESSON" ? data.cod_leccion : data.id
    }`;

    const quizDataResponse = await HttpClient().get(url);

    if (quizDataResponse.error) {
      setOpenOpenLoader(false);
      showToast("No se pudo cargar información. Intenta nuevamente.", "error");
      return;
    }
    console.log(quizDataResponse);
    setQuizData(quizDataResponse.data);
  };

  useEffect(() => {
    if (quizData) {
      setOpenOpenLoader(false);
    }
  }, [quizData]);

  useEffect(() => {
    if (data) {
      setOpenOpenLoader(true);
      loadData();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      setStep(0)
    }
  }, [data, data?.cod_leccion, data?.id]);

  return (
    <Grid
      container
      columns={{ xs: 4, md: 12 }}
      sx={{
        maxWidth: "900px",
        margin: "auto",
        mt: 3,
        p: 3,
        backgroundColor: "#fff",
        padding: "10px 10px 10px 10px",
      }}
    >
      <OverlayLoader open={openLoader} />
      <Grid container spacing={2} display="flex" flexDirection="row">
        {step == 0 && quizData ? (
          <TestInstructions
            name={data.nombre}
            onFinish={() => {
              setStep(1);
            }}
          />
        ) : null}
        {step == 1 && quizData ? (
          <ReadingTest
            id={quizData.id}
            title={quizData.titulo}
            content={quizData.contenido}
            onFinish={(seconds) => {
              secondsReading.current = seconds
              setStep(2);
            }}
          />
        ) : null}
        {step == 2 ? (
          <QuizContainer
            courseCode={courseCode}
            type={type}
            data={{ ...data, cod_cuestionario: quizData.cod_cuestionario, numero_palabras: quizData.numero_palabras }}
            key={"quiz-" + quizData.cod_cuestionario}
            configPercentage={configPercentage}
            onFinalize={onFinalize}
            onContinue={onContinue}
            readingTimeSeconds={secondsReading.current}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};

export default TestContainer;
